<h1>Invoices</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (tab of tabs | visibleFinanceTabs; track tab) {
    <a mat-tab-link (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
      {{tab.title}}
    </a>
  }
</nav>

<div class="actionwrapper">
  <div class="actions">
    <button mat-raised-button color="primary" (click)="reloadItems()">Refresh</button>
  </div>
</div>

<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.id}}</td>
  </ng-container>

  <ng-container matColumnDef="invoiceNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice #</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.invoiceNumber}}</td>
  </ng-container>

  <ng-container matColumnDef="contractId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.contractId}}</td>
  </ng-container>

  <ng-container matColumnDef="settlementBatchId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Settlement ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.settlementBatchId || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="issueDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Issue Date</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.issueDate | date:'mediumDate'}}</td>
  </ng-container>

  <ng-container matColumnDef="dueDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.dueDate | date:'mediumDate'}}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.status}}</td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.amount}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
  <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
</table>

<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
